import script from "./PaymentPending.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentPending.vue?vue&type=script&setup=true&lang=js"

import "./PaymentPending.vue?vue&type=style&index=0&id=13b509e1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13b509e1"]])

export default __exports__